<template>
  <v-text-field
    v-model="cep"
    :label="$t('CEP')"
    v-mask="'##.###-###'"
    name="cep"
    @blur="buscaCep"
    :loading="loadingCep"
    class="
      input-style
      font-size-input
      text-light-input
      placeholder-light
      input-icon
    "
    dense
    flat
    filled
    solo
  />
</template>

<script>
import DataService from "@/services/ComumDataService";
import {
  cachedCidades,
  isCachedCidadesValid,
  loadCachedCidades,
} from "@/services/cacheCidades";

export default {
  name: "BuscaCep",
  props: {
    cepProp: { type: String, required: true },
    carregarCidades: { type: Boolean, required: false, default: true },
  },
  data() {
    return {
      cep: this.cepProp,
      loadingCep: false,
      loadingCidades: false,
    };
  },
  mounted() {
    if (this.carregarCidades) {
      this.getCidades();
    }
  },
  watch: {
    cepProp(val) {
      this.cep = val;
    },
    cep(val) {
      this.$emit("cep", val);
    },
  },
  methods: {
    async buscaCep() {
      if (this.cep.length >= 8) {
        this.loadingCep = true;
        try {
          const response = await DataService.buscaCep(
            this.limpaMascara(this.cep)
          );
          const { localidade, uf, logradouro, bairro } = response.data;
          const cidadeResponse = await DataService.findCidade({
            cidade: localidade,
            uf,
          });
          this.$emit("cidade", cidadeResponse.data);
          this.$emit("logradouro", logradouro);
          this.$emit("bairro", bairro);
          this.$emit("endereco", {
            cidade: cidadeResponse.data,
            logradouro: logradouro,
            bairro: bairro,
          });
        } catch (error) {
          console.error("Erro na busca de CEP:", error);
        } finally {
          this.loadingCep = false;
        }
      }
    },
    async getCidades() {
      if (isCachedCidadesValid()) {
        this.$emit("cidades", cachedCidades);
        return;
      }
      this.setLoadingCidades(true);
      try {
        const cidades = await loadCachedCidades(() => DataService.getCidades());
        this.$emit("cidades", cidades);
      } catch (error) {
        console.error("Erro ao buscar cidades:", error);
      } finally {
        this.setLoadingCidades(false);
      }
    },
    setLoadingCidades(value) {
      this.loadingCidades = value;
      this.$emit("loading-cidades", value);
    },
    limpaMascara(valor) {
      return valor.replace(/\D/g, "");
    },
  },
};
</script>

<style scoped>
/* Seus estilos */
</style>
